import { ComponentHeader } from '../shared/ComponentHeader'
import { ComponentTitle } from '../shared/ComponentTitle'
import clsx from 'clsx'
import { ChartRadarDataSchema, ChartRadarUISchema } from './types'
import { RadarChartBody } from './RadarChartBody'
import { ComponentActionsContainer } from '../shared/ComponentActionsContainer'
import { getComponentHeights } from '../utils'

export function ChartRadarContent({
  uiSchema,
  dataSchema,
  tileFilters,
}: {
  uiSchema: ChartRadarUISchema
  dataSchema: ChartRadarDataSchema
  tileFilters?: React.ReactNode
}) {
  const { title = undefined, description = undefined, emphasizeHeader } = uiSchema
  const hasHeader = !!title && !!tileFilters
  const { contentHeight } = getComponentHeights(emphasizeHeader, hasHeader)
  return (
    <div className="flex h-full flex-col">
      {hasHeader && (
        <ComponentHeader emphasize={emphasizeHeader}>
          <ComponentTitle title={title} description={description} />
          <ComponentActionsContainer>{tileFilters}</ComponentActionsContainer>
        </ComponentHeader>
      )}
      <div className={clsx({ 'pt-5': hasHeader })} style={{ height: contentHeight }}>
        <RadarChartBody chartConfig={uiSchema.chartConfig} data={dataSchema.data} />
      </div>
    </div>
  )
}
